import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, Signal } from '@angular/core';
import { MDStepperStepComponent } from '@melodic-ui/components';
import { SchedulerStateService, SchedulerStep } from '@lb/schedule/services/scheduler-state.service';

@Component({
	standalone: true,
	imports: [CommonModule, MDStepperStepComponent],
	selector: 'lrnr-scheduler-progress',
	templateUrl: './scheduler-progress.component.html',
	styleUrls: ['./scheduler-progress.component.scss']
})
export class SchedulerProgressComponent {
	orientation = input<'horizontal' | 'vertical'>('vertical');

	private readonly _schedulerStateService = inject(SchedulerStateService);

	schedulerSteps: Signal<SchedulerStep[]> = computed(() => this._schedulerStateService.schedulerSteps());
	completedSchedulerSteps = this._schedulerStateService.completedSchedulerSteps;
	isAllStepsComplete: Signal<boolean> = this._schedulerStateService.isAllStepsComplete;

	isStepActive = (step: SchedulerStep): Signal<boolean> => computed(() => this._schedulerStateService.currentSchedulerStep().id === step.id);

	// Final step is not complete
	isStepComplete = (step: SchedulerStep): Signal<boolean> => computed(() => (step.id === 4 ? false : this.completedSchedulerSteps().includes(step.id)));

	goToStep(step: SchedulerStep): void {
		const stepIndex = this.schedulerSteps().findIndex((s) => s.id === step.id);
		this._schedulerStateService.setCurrentSchedulerStepIndex(stepIndex);
	}
}
